export function conditional(decisions, conditionalVariantValues, id, type = 'EditorialTable', side = 1) {
	const conditionalValues = getConditionalVariantValue(decisions, conditionalVariantValues, id, type, side);
	if (conditionalValues && conditionalValues.length > 0) {
		return conditionalValues[0].value;
	} else {
		// console.log('no match: ', id, decisions.normalizedDecisions);
		return null;
	}
}

export function conditionals(decisions, conditionalVariantValues, id, type = 'EditorialTable', side = null) {
	let conditionalValues;
	if (side === null) {
		conditionalValues = [
			...getConditionalVariantValue(decisions, conditionalVariantValues, id, type, 1) ?? [],
			...getConditionalVariantValue(decisions, conditionalVariantValues, id, type, 2) ?? []
		];
	} else {
		conditionalValues = getConditionalVariantValue(decisions, conditionalVariantValues, id, type, side);
	}
	return conditionalValues;
}

function getConditionalVariantValue(decisions, conditionalVariantValues, id, type, side = 1) {
	if (conditionalVariantValues === null) {
		return null;
	}

	// WORKAROUND: Remove 'RETURN_' from id
	id = id.replace('REDTAB.RETURN_', '').replace('RETURN_', '');

	// collect all values where id and decisions match
	const key = type + '.' + id + '.' + side;
	if (key in conditionalVariantValues) {
		const matchingValues = conditionalVariantValues[key].filter(
			conditionalVariantValue => conditionalVariantValue.conditions.reduce(
				(match, condition) => (condition in decisions.normalizedDecisions && decisions.normalizedDecisions[condition].isIncluded) && match,
				true)
		);

		if (matchingValues.length > 0) {
			return matchingValues;
		}
	}
	//console.log('no matching decisions found', key, includedDecisions);
	return null;

}
